module.exports = window.XMLHttpRequest;



//////////////////
// WEBPACK FOOTER
// ./~/httpplease/lib/xhr-browser.js
// module id = 1307
// module chunks = 4